import { MerchantService } from 'src/app/_services/merchant.service';
import { Component, inject, OnInit } from '@angular/core';

@Component({
    selector: 'app-configurations-payment-methods',
    templateUrl: './configurations-payment-methods.component.html',
    styleUrls: ['./configurations-payment-methods.component.scss'],
    standalone: false
})
export class ConfigurationsPaymentMethodsComponent implements OnInit {
  private readonly merchantService: MerchantService = inject(MerchantService);

  isPayPalActive: boolean = false;
  isIGFSActive: boolean = false;

  ngOnInit(): void {
    this.isPayPalActive = this.merchantService.currentMerchant.settings.isPAYPALActive;
    this.isIGFSActive = this.merchantService.currentMerchant.settings.isIGFSActive;
  }
}
